import { render, staticRenderFns } from "./flowList.vue?vue&type=template&id=2d6396a7&scoped=true"
import script from "./flowList.vue?vue&type=script&lang=js"
export * from "./flowList.vue?vue&type=script&lang=js"
import style0 from "./flowList.vue?vue&type=style&index=0&id=2d6396a7&prod&lang=scss&scoped=true"
import style1 from "./flowList.vue?vue&type=style&index=1&id=2d6396a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6396a7",
  null
  
)

export default component.exports